import React from 'react';

import { Container } from './styles';

interface TooltipProps {
  title: string;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ children, title, className }) => {
  return (
    <Container className={className}>
      {children}
      <div />
      <div>
        <span>{title}</span>
      </div>
    </Container>
  );
};

export default Tooltip;
